import {ContractorCategoryDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
import { UserState } from '../../reducers/UserReducer';
const FUNCTION_CODE = 'GET_ALL_CONTRACTORS';

export async function getAllContractorCategories(
    userData: UserState["userProfileData"],
    params: string,
    page: number,
) {
    try {
        const contractors = await ContractorCategoryDao.getAllContractorCategories(userData?.userToken as string, params, page);

        return contractors;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
